import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetCustomDomainsResponse = App.Http.Responses.CustomDomain.GetCustomDomainsResponse;
import GetCustomDomainResponse = App.Http.Responses.CustomDomain.GetCustomDomainResponse;
import StoreCustomDomainRequest = App.Http.Requests.CustomDomain.StoreCustomDomainRequest;
import UpdateCustomDomainRequest = App.Http.Requests.CustomDomain.UpdateCustomDomainRequest;
import GetCustomDomainsRequest = App.Http.Requests.CustomDomain.GetCustomDomainsRequest;
import GetCustomDomainRequest = App.Http.Requests.CustomDomain.GetCustomDomainRequest;

class CustomDomainsApi extends TenantBaseApi {
    async index(request?: GetCustomDomainsRequest): Promise<GetCustomDomainsResponse> {
        return await this.get<GetCustomDomainsResponse, GetCustomDomainsRequest>("/custom-domains", {
            params: request,
        });
    }

    async show(domainId: string, request?: GetCustomDomainRequest): Promise<GetCustomDomainResponse> {
        return await this.get<GetCustomDomainResponse, GetCustomDomainRequest>(`/custom-domains/${domainId}`, {
            params: request,
        });
    }

    async store(request: StoreCustomDomainRequest): Promise<GetCustomDomainResponse> {
        return await this.post<GetCustomDomainResponse, StoreCustomDomainRequest>("/custom-domains", request);
    }

    async update(domainId: string, request: UpdateCustomDomainRequest): Promise<GetCustomDomainResponse> {
        return await this.patch<GetCustomDomainResponse, UpdateCustomDomainRequest>(
            `/custom-domains/${domainId}`,
            request
        );
    }

    async destroy(domainId: string): Promise<null> {
        return await this.delete<null, void>(`/custom-domains/${domainId}`);
    }
}

export const customDomainsApi = new CustomDomainsApi();
